// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heading-capability {
    background: #D8D8D8 ;
    color: #1E1E1E;
    box-sizing: border-box;
    position: relative;
  
    /* ⬅️ INI KUNCI INTRO & OUTRO */
    padding: 5vh  40vh;
    overflow-x: hidden;
    overflow-y: visible;
    width: 100%;
    max-width: calc(100 * var(--vw));
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    margin: 0;
  }
  
  /* Scroll hint */
  .hc-scroll {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0.6;
    font-size: 14px;
  }
  
  /* List */
  .hc-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 0;
  }
  
  /* Row */
  .hc-list li {
    font: 500 clamp(60px, calc(15 * var(--vw)), 250px) / 0.8 "Satoshi", sans-serif;
    letter-spacing: -0.06em;
    display: flex;
    overflow: hidden;
    width: 100%;
    max-width: calc(100 * var(--vw));
    justify-content: center;
    align-items: center;
  }
  
  /* Letter */
  .hc-letter {
    position: relative;
    display: inline-block;
  }
  
  /* Duplicate letter */
  .hc-letter span:last-child {
    position: absolute;
    bottom: 100%;
    left: 0;
  }

  /* Space */
  .hc-space {
    display: inline-block;
    width: 0.2em; /* Adjust spacing width as needed */
  }

/* ==================== MEDIA QUERIES ==================== */

/* Mobile (max-width: 768px) */
@media screen and (max-width: 768px) {
  section.heading-capability {
    padding: 8vh calc(4 * var(--vw)) 15vh !important;
    min-height: auto !important;
    height: auto !important;
    justify-content: flex-start !important;
    margin: 0 !important;
    margin-top: -5vh !important; /* Compensate for previous section's padding */
    box-sizing: border-box !important;
    position: relative;
    z-index: 1 !important;
    background: #D8D8D8 !important; /* Ensure background stays visible */
  }

  section.heading-capability .hc-scroll {
    display: none !important;
  }

  section.heading-capability .hc-list {
    gap: 0.5rem !important;
    margin: 0 !important;
    justify-content: flex-start !important;
    align-items: center !important;
    padding: 0 1rem !important;
    width: 100% !important;
    box-sizing: border-box !important;
  }

  section.heading-capability .hc-list li {
    font-size: clamp(64px, calc(14 * var(--vw)), 100px) !important;
    font-weight: 600 !important;
    line-height: 1.15 !important;
    letter-spacing: -0.04em !important;
    padding: 0.5rem 0 !important;
    margin: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    text-align: center !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    overflow: hidden !important;
    box-sizing: border-box !important;
  }

  section.heading-capability .hc-letter {
    display: inline-block !important;
    position: relative !important;
  }

  section.heading-capability .hc-letter span:last-child {
    position: absolute !important;
    bottom: 100% !important;
    left: 0 !important;
  }
}

/* Small Mobile (max-width: 480px) */
@media screen and (max-width: 480px) {
  section.heading-capability {
    padding: 6vh calc(3 * var(--vw)) 12vh !important;
    margin-top: -3vh !important; /* Compensate for previous section's padding */
    background: #D8D8D8 !important; /* Ensure background stays visible */
  }

  section.heading-capability .hc-list {
    padding: 0 0.5rem !important;
    gap: 0.3rem !important;
  }

  section.heading-capability .hc-list li {
    font-size: clamp(56px, calc(12 * var(--vw)), 80px) !important;
    padding: 0.4rem 0 !important;
    line-height: 1.2 !important;
  }
}

/* iPhone Landscape (max-width: 896px dan max-height: 500px) */
@media screen and (max-width: 896px) and (max-height: 500px) and (orientation: landscape) {
  section.heading-capability {
    padding: 4vh calc(4 * var(--vw)) 8vh !important;
    background: #D8D8D8 !important; /* Ensure background stays visible */
  }

  section.heading-capability .hc-list {
    gap: 0.2rem !important;
  }

  section.heading-capability .hc-list li {
    font-size: clamp(48px, calc(10 * var(--vw)), 72px) !important;
  }
}
  `, "",{"version":3,"sources":["webpack://./src/component/heading-capability/heading-capability.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,cAAc;IACd,sBAAsB;IACtB,kBAAkB;;IAElB,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,SAAS;EACX;;EAEA,gBAAgB;EAChB;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,YAAY;IACZ,eAAe;EACjB;;EAEA,SAAS;EACT;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,MAAM;EACR;;EAEA,QAAQ;EACR;IACE,8EAA8E;IAC9E,uBAAuB;IACvB,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,gCAAgC;IAChC,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA,WAAW;EACX;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA,qBAAqB;EACrB;IACE,kBAAkB;IAClB,YAAY;IACZ,OAAO;EACT;;EAEA,UAAU;EACV;IACE,qBAAqB;IACrB,YAAY,EAAE,mCAAmC;EACnD;;AAEF,4DAA4D;;AAE5D,8BAA8B;AAC9B;EACE;IACE,gDAAgD;IAChD,2BAA2B;IAC3B,uBAAuB;IACvB,sCAAsC;IACtC,oBAAoB;IACpB,2BAA2B,EAAE,8CAA8C;IAC3E,iCAAiC;IACjC,kBAAkB;IAClB,qBAAqB;IACrB,8BAA8B,EAAE,oCAAoC;EACtE;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,sCAAsC;IACtC,8BAA8B;IAC9B,0BAA0B;IAC1B,sBAAsB;IACtB,iCAAiC;EACnC;;EAEA;IACE,8DAA8D;IAC9D,2BAA2B;IAC3B,4BAA4B;IAC5B,kCAAkC;IAClC,4BAA4B;IAC5B,oBAAoB;IACpB,sBAAsB;IACtB,0BAA0B;IAC1B,6BAA6B;IAC7B,wBAAwB;IACxB,kCAAkC;IAClC,8BAA8B;IAC9B,2BAA2B;IAC3B,iCAAiC;EACnC;;EAEA;IACE,gCAAgC;IAChC,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;IAC7B,uBAAuB;IACvB,kBAAkB;EACpB;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,gDAAgD;IAChD,2BAA2B,EAAE,8CAA8C;IAC3E,8BAA8B,EAAE,oCAAoC;EACtE;;EAEA;IACE,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;IACE,6DAA6D;IAC7D,4BAA4B;IAC5B,2BAA2B;EAC7B;AACF;;AAEA,8DAA8D;AAC9D;EACE;IACE,+CAA+C;IAC/C,8BAA8B,EAAE,oCAAoC;EACtE;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,6DAA6D;EAC/D;AACF","sourcesContent":[".heading-capability {\n    background: #D8D8D8 ;\n    color: #1E1E1E;\n    box-sizing: border-box;\n    position: relative;\n  \n    /* ⬅️ INI KUNCI INTRO & OUTRO */\n    padding: 5vh  40vh;\n    overflow-x: hidden;\n    overflow-y: visible;\n    width: 100%;\n    max-width: calc(100 * var(--vw));\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    min-height: 100vh;\n    margin: 0;\n  }\n  \n  /* Scroll hint */\n  .hc-scroll {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    opacity: 0.6;\n    font-size: 14px;\n  }\n  \n  /* List */\n  .hc-list {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    gap: 0;\n  }\n  \n  /* Row */\n  .hc-list li {\n    font: 500 clamp(60px, calc(15 * var(--vw)), 250px) / 0.8 \"Satoshi\", sans-serif;\n    letter-spacing: -0.06em;\n    display: flex;\n    overflow: hidden;\n    width: 100%;\n    max-width: calc(100 * var(--vw));\n    justify-content: center;\n    align-items: center;\n  }\n  \n  /* Letter */\n  .hc-letter {\n    position: relative;\n    display: inline-block;\n  }\n  \n  /* Duplicate letter */\n  .hc-letter span:last-child {\n    position: absolute;\n    bottom: 100%;\n    left: 0;\n  }\n\n  /* Space */\n  .hc-space {\n    display: inline-block;\n    width: 0.2em; /* Adjust spacing width as needed */\n  }\n\n/* ==================== MEDIA QUERIES ==================== */\n\n/* Mobile (max-width: 768px) */\n@media screen and (max-width: 768px) {\n  section.heading-capability {\n    padding: 8vh calc(4 * var(--vw)) 15vh !important;\n    min-height: auto !important;\n    height: auto !important;\n    justify-content: flex-start !important;\n    margin: 0 !important;\n    margin-top: -5vh !important; /* Compensate for previous section's padding */\n    box-sizing: border-box !important;\n    position: relative;\n    z-index: 1 !important;\n    background: #D8D8D8 !important; /* Ensure background stays visible */\n  }\n\n  section.heading-capability .hc-scroll {\n    display: none !important;\n  }\n\n  section.heading-capability .hc-list {\n    gap: 0.5rem !important;\n    margin: 0 !important;\n    justify-content: flex-start !important;\n    align-items: center !important;\n    padding: 0 1rem !important;\n    width: 100% !important;\n    box-sizing: border-box !important;\n  }\n\n  section.heading-capability .hc-list li {\n    font-size: clamp(64px, calc(14 * var(--vw)), 100px) !important;\n    font-weight: 600 !important;\n    line-height: 1.15 !important;\n    letter-spacing: -0.04em !important;\n    padding: 0.5rem 0 !important;\n    margin: 0 !important;\n    width: 100% !important;\n    max-width: 100% !important;\n    text-align: center !important;\n    display: flex !important;\n    justify-content: center !important;\n    align-items: center !important;\n    overflow: hidden !important;\n    box-sizing: border-box !important;\n  }\n\n  section.heading-capability .hc-letter {\n    display: inline-block !important;\n    position: relative !important;\n  }\n\n  section.heading-capability .hc-letter span:last-child {\n    position: absolute !important;\n    bottom: 100% !important;\n    left: 0 !important;\n  }\n}\n\n/* Small Mobile (max-width: 480px) */\n@media screen and (max-width: 480px) {\n  section.heading-capability {\n    padding: 6vh calc(3 * var(--vw)) 12vh !important;\n    margin-top: -3vh !important; /* Compensate for previous section's padding */\n    background: #D8D8D8 !important; /* Ensure background stays visible */\n  }\n\n  section.heading-capability .hc-list {\n    padding: 0 0.5rem !important;\n    gap: 0.3rem !important;\n  }\n\n  section.heading-capability .hc-list li {\n    font-size: clamp(56px, calc(12 * var(--vw)), 80px) !important;\n    padding: 0.4rem 0 !important;\n    line-height: 1.2 !important;\n  }\n}\n\n/* iPhone Landscape (max-width: 896px dan max-height: 500px) */\n@media screen and (max-width: 896px) and (max-height: 500px) and (orientation: landscape) {\n  section.heading-capability {\n    padding: 4vh calc(4 * var(--vw)) 8vh !important;\n    background: #D8D8D8 !important; /* Ensure background stays visible */\n  }\n\n  section.heading-capability .hc-list {\n    gap: 0.2rem !important;\n  }\n\n  section.heading-capability .hc-list li {\n    font-size: clamp(48px, calc(10 * var(--vw)), 72px) !important;\n  }\n}\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
